
import RouterUtil from '@/utils/router.util';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
class SideMenu extends Vue {
  showSidebar = true;

  get menuTitle(): string {
    return (
      this.$route.matched[this.$route.matched.length - 2]?.meta?.title ||
      this.$route.matched[this.$route.matched.length - 1]?.meta?.title ||
      ''
    );
  }

  get menuItems(): any[] {
    const currentRoute = this.$route.matched[this.$route.matched.length - 1];
    const parentRoute = this.$route.matched[this.$route.matched.length - 2];

    const userRoutes = this.$store.state.user.userRoutes;

    // Se não há rota pai, retorna apenas a página inicial
    if (!parentRoute) {
      return [
        {
          name: 'Página Inicial',
          description: '',
          path: currentRoute.path || '/',
        },
      ];
    }

    // Busca todos os irmãos (rotas filhas do mesmo pai)
    const siblings = RouterUtil.getChildrenByParentPath(
      parentRoute.path,
      userRoutes
    ).filter(
      (router) =>
        !router.meta?.hiddenOnNavigation && router.meta?.active !== false
    );

    // Se não há irmãos, retorna apenas a rota atual
    if (!siblings || siblings.length <= 1) {
      return [
        {
          name: Array.isArray(currentRoute.meta?.labels)
            ? currentRoute.meta.labels.join(' ')
            : currentRoute.name || currentRoute.meta?.label || '',
          path: currentRoute.path || '/',
          description: currentRoute.meta?.description || '',
          blocked: currentRoute.meta?.blocked,
        },
      ];
    }

    // Monta o menu com base nos irmãos
    const siblingsMenuItem = siblings.map((sibling: any) => {
      return {
        name: Array.isArray(sibling.meta?.labels)
          ? sibling.meta.labels.join(' ')
          : sibling.name || sibling.meta?.label || '',
        path: sibling.path || '/',
        description: sibling.meta?.description || '',
        blocked: sibling.meta.blocked,
      };
    });

    return siblingsMenuItem;
  }

  isRouteActive(path: string) {
    return (
      this.$route.matched[this.$route.matched.length - 1].path
        .split('/')
        .pop() === path
    );
  }
}

export default SideMenu;
